const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://docs.redwerks.org',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo: 'https://docs.redwerks.org/redwerks-logo.png',
    logoLink: 'https://redwerks.org/',
    title: ``,
    githubUrl: 'https://github.com/redwerks/docs.redwerks.org',
    helpUrl: '',
    tweetText: '',
    social: ``,
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/introduction', // add trailing slash if enabled above
      '/codeblock',
    ],
    collapsedNav: [
      '/codeblock', // add trailing slash if enabled above
    ],
    links: [{ text: 'Redwerks', link: 'https://redwerks.org' }],
    frontline: false,
    ignoreIndex: true,
    title:
      "<a href='https://docs.redwerks.org/'>Documentation</a><div class='greenCircle'></div>",
  },
  siteMetadata: {
    title: 'Documentation | Redwerks',
    description: 'General documentation for Redwerks projects',
    ogImage: null,
    docsLocation: 'https://github.com/redwerks/docs.redwerks.org/tree/master/content',
    favicon: 'https://graphql-engine-cdn.hasura.io/img/hasura_icon_black.svg',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Redwerks Documentation',
      short_name: 'RedwerksDocs',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
